import React from 'react'
import List from '../crud/list'
import menuItems from './menuItems'

const columns = [
  { title: 'Timer Type', prop: 'timer_type' },
  { title: 'Created', prop: 'created_at', format: 'date' },
  { title: 'Updated', prop: 'updated_at', format: 'date' }
]

const filters = [
  { name: 'Filter by timer type', prop: 'filters.timer_type_ilike', type: 'text', enabled: true },
  { name: 'Show deleted', prop: 'with_deleted', type: 'bool', value: true, enabled: false }
]

const defaults = {
  order: [
    { column: 'updated_at', direction: 'desc' }
  ]
}

const TimerTypes = (props) => (
  <List
    title='Timer Types'
    apiPath='admin/timer_types'
    columns={columns}
    filters={filters}
    defaults={defaults}
    locationPathname={props.location.pathname}
    locationSearch={props.location.search}
    buildMenuItems={menuItems}
  />
)

export default TimerTypes
